import { executeRequest, Request } from '@jfs/network'
import { AESEncryption, getRandomAlphaNumString, RSAEncryption } from '@jfs/utils'
import { Buffer } from 'buffer'
import { RootStore } from '../data/store'
import { getNetworkResponseError, isOTPRequiredChannel, isStatusOK, isStatusSuccess } from '../util/utill'
import { APIEndPoints } from './APIEndPoints'
import { apiConfig } from './config'
import { FAILED, sendEventApi, SUCCESS } from './sendEvent'

const responseParser = (data: any, tokens: any, request: Request<{}>) => {
  if (isStatusOK(data) && isStatusSuccess(data?.data)) {
    sendEventApi(tokens, request, {
      status: SUCCESS,
      biometricDeviceInfo: RootStore.agent.deviceInfo.biometricDeviceInfo,
    })
    return {
      userAccessToken: data?.data?.session?.accessToken?.tokenValue,
      userRefreshToken: data?.data?.session?.refreshToken?.tokenValue,
      userAccessTokenExpiry: data?.data?.session?.accessToken?.expiresIn,
      userRefreshTokenExpiry: data?.data?.session?.refreshToken?.expiresIn,
      userIdentifierToken: data?.data?.session?.userIdentifierToken,
      UIDToken: data?.data?.aadhaar?.uidtoken,
      referenceNumber: data?.data?.aadhaar?.referenceNumber,
      jpbToken: data?.data?.aadhaar?.jpbToken,
      authorizationCode: data?.data?.authorizationCode,
    }
  } else {
    throw data
  }
}

export const authenticateModeOtp = (tokens: any, reqParam: any, authParams) => {
  const updatedReqParam = {
    ...reqParam,
    authenticateList: [
      ...(reqParam.authenticateList || []),
      {
        mode: 49,
        trustedContainerDetails: {
          authenticationMode: 49,
          authenticationToken: authParams.encToken,
          id: '1',
          encKey: authParams.encKey,
          parentOrigin: authParams.parentOrigin,
          transactionType: authParams.transactionType,
          type: 'AUTH_DATA',
        },
      },
    ],
  }
  const request: Request<{}> = {
    apiPath: APIEndPoints.authenticateOtp,
    method: 'POST',
    config: apiConfig(tokens),
    body: reqParam,
  }
  sendEventApi(tokens, request, {
    status: 'INITIATED',
    biometricDeviceInfo: RootStore.agent.deviceInfo.biometricDeviceInfo,
  })
  return executeRequest(request)
    .then((data) => {
      return responseParser(data, tokens, request)
    })
    .catch((error) => {
      console.log('htag error', error)
      const res = getNetworkResponseError(error?.data)
      console.log('htag error fin', error)
      sendEventApi(tokens, request, {
        status: FAILED,
        errorCode: res.code ?? null,
        errorDescription: error,
        biometricDeviceInfo: RootStore.agent.deviceInfo.biometricDeviceInfo,
      })
      throw res
    })
}

export const authenticateOtp = (tokens: any, reqParam: any) => {
  const request: Request<{}> = {
    apiPath: APIEndPoints.authenticateOtp,
    method: 'POST',
    config: apiConfig(tokens),
    body: reqParam,
  }
  sendEventApi(tokens, request, {
    status: 'INITIATED',
    biometricDeviceInfo: RootStore.agent.deviceInfo.biometricDeviceInfo,
  })
  return executeRequest(request)
    .then((data) => {
      return responseParser(data, tokens, request)
    })
    .catch((error) => {
      console.log('htag error', error)
      const res = getNetworkResponseError(error?.data)
      console.log('htag error fin', error)
      sendEventApi(tokens, request, {
        status: FAILED,
        errorCode: res.code ?? null,
        errorDescription: error,
        biometricDeviceInfo: RootStore.agent.deviceInfo.biometricDeviceInfo,
      })
      throw res
    })
}

export const getAuthenticateOtpForBiometric = (
  otp: string,
  fingerPrintData: string,
  mobileNumber: string,
  userId: string,
  aadharNum: string,
  aadhaarToken: string,
  name: string,
  consent: string,
  authMode: 'FACE' | 'FINGER_PRINT',
) => {
  const { REACT_APP_JFS_PUBLIC_KEY } = process.env
  const PUBLIC_ENC_KEY: any = REACT_APP_JFS_PUBLIC_KEY

  let randomEncryptionKey = getRandomAlphaNumString(32)
  const encryptionKey = RSAEncryption(randomEncryptionKey, PUBLIC_ENC_KEY)
  let encOtp = AESEncryption(randomEncryptionKey, otp)
  let encUserAccessToken = AESEncryption(randomEncryptionKey, RootStore?.bcAppInfo?.userAccessToken)
  console.log(RootStore?.agent?.agentInfo?.agentUserLoginId, 'agentuserloginidd::')

  const firstName = getFirstName(name)
  const lastName = getLastName(name)
  console.log(aadhaarToken, 'checkaadhartoken::')
  if (window?.AepsWebViewInterface) {
    return {
      user: {
        userId: RootStore?.agent?.agentInfo?.agentUserLoginId,
        userId: RootStore?.agent?.agentInfo?.agentUserLoginId,
        mobile: {
          mobileNumber: RootStore?.agent?.agentInfo?.agentMobileNumber,
          countryCode: '91',
        },
        entityType: 2,
        name: {
          firstName,
          lastName,
        },
      },
      scope: 'SESSION',
      authenticateList: [
        ...(isOTPRequiredChannel(RootStore.agent.session.CHANNEL_ID)
          ? [
              {
                mode: 18,
                value: encOtp, //ency
                action: 'verify',
              },
            ]
          : []),
        {
          mode: 15,
          accessToken: encUserAccessToken,
          userIdentifierToken: RootStore?.bcAppInfo?.userIdentifier,
        },
        {
          mode: authMode === 'FACE' ? 44 : 10,
          aadhaar: {
            ...(aadharNum && { number: aadharNum }),
            ...(aadhaarToken && { token: aadhaarToken }),
          },
          consent: btoa(consent),
          biometrics: fingerPrintData,
        },
      ],
      ...{
        secure: {
          encryptionKey: encryptionKey,
        },
      },
      purpose: 1,
    }
  }

  return {
    user: {
      mobile: {
        mobileNumber: mobileNumber,
        countryCode: '91',
      },
      userId,
      entityType: 2,
    },
    scope: 'SESSION',
    authenticateList: [
      {
        mode: '18',
        value: encOtp,
        action: 'verify',
      },
    ],
    secure: {
      encryptionKey: encryptionKey,
    },
    purpose: 1,
  }
}
export const getAuthenticateCustomerRequest = (fingerprintData, consent, authMode) => {
  const { REACT_APP_JFS_PUBLIC_KEY } = process.env
  const PUBLIC_ENC_KEY: any = REACT_APP_JFS_PUBLIC_KEY

  let randomEncryptionKey = getRandomAlphaNumString(32)
  const encryptionKey = RSAEncryption(randomEncryptionKey, PUBLIC_ENC_KEY)

  let encUserAccessToken = AESEncryption(randomEncryptionKey, RootStore?.bcAppInfo?.userAccessToken)
  return {
    user: {
      userId: RootStore?.customerDetails?.remittanceUserId,
      mobile: {
        mobileNumber: RootStore.customerDetails.mobile,
        countryCode: '91',
      },
      entityType: 3,
      name: {
        firstName: RootStore?.customerDetails?.firstName,
        lastName: RootStore?.customerDetails?.lastName,
      },
    },
    scope: 'SESSION',
    authenticateList: [
      {
        mode: authMode === 'FACE' ? 44 : 10,
        aadhaar: {
          token: RootStore?.customerDetails?.aadhaarToken,
        },
        consent: Buffer.from(JSON.stringify(consent)).toString('base64'),
        biometrics: fingerprintData,
      },
    ],
    ...{
      secure: {
        encryptionKey: encryptionKey,
      },
    },
    purpose: 1,
  }
}

export const getAuthenticateOtpForCustomer = (otp: string, mobileNumber: string) => {
  const { REACT_APP_JFS_PUBLIC_KEY } = process.env
  const PUBLIC_ENC_KEY: any = REACT_APP_JFS_PUBLIC_KEY

  let randomEncryptionKey = getRandomAlphaNumString(32)
  const encryptionKey = RSAEncryption(randomEncryptionKey, PUBLIC_ENC_KEY)
  let encOtp = AESEncryption(randomEncryptionKey, otp)

  return {
    user: {
      mobile: {
        mobileNumber,
        countryCode: '91',
      },
      emailAddress: '',
    },
    scope: 'SESSION',
    authenticateList: [
      {
        mode: 18,
        value: encOtp,
        action: 'verify',
      },
    ],
    secure: {
      encryptionKey,
    },
    purpose: 1,
    extraInfo: '20000033535',
  }
}

export const getAuthenticateOtpForAgent = (otp: string, mobileNumber: string) => {
  const { REACT_APP_JFS_PUBLIC_KEY } = process.env
  const PUBLIC_ENC_KEY: any = REACT_APP_JFS_PUBLIC_KEY

  let randomEncryptionKey = getRandomAlphaNumString(32)
  const encryptionKey = RSAEncryption(randomEncryptionKey, PUBLIC_ENC_KEY)
  let encOtp = AESEncryption(randomEncryptionKey, otp)

  return {
    user: {
      mobile: {
        mobileNumber,
        countryCode: '91',
      },
      emailAddress: '',
      entityType: 2,
      userId: RootStore?.agent?.agentInfo?.agentUserLoginId,
    },
    scope: 'SESSION',
    authenticateList: [
      {
        mode: 18,
        value: encOtp,
        action: 'verify',
      },
    ],
    secure: {
      encryptionKey,
    },
    purpose: 1,
    extraInfo: '20000033535',
  }
}

export const getUserAuthModeRequest = (authenticationToken: any, authParams: any) => {
  return {
    user: {
      userId: RootStore?.agent?.agentInfo?.agentUserLoginId,
      entityType: 2,
    },
    scope: 'SESSION',
    authenticateList: [
      {
        mode: 49,
        trustedContainerDetails: {
          authenticationMode: 49,
          authenticationToken: authParams.encToken,
          id: '1',
          encKey: authParams.encKey,
          parentOrigin: authParams.parentOrigin,
          transactionType: authParams.transactionType,
          type: 'AUTH_DATA',
        },
      },
    ],
    purpose: 1,
  }
}

export const getUserAuthRequest = (authenticationToken: any) => {
  return {
    user: {
      userId: RootStore?.agent?.agentInfo?.agentUserLoginId,
      entityType: 2,
    },
    scope: 'SESSION',
    authenticateList: [
      {
        mode: '3',
        trustedContainerDetails: {
          authenticationMode: '3',
          authenticationToken,
          id: '1',
        },
      },
    ],
    purpose: 1,
  }
}

export const getAgentAuthenticationRquest = (
  fingerPrintData: string,
  consent: string,
  fingerPrintDataAuthMode?: any,
) => {
  const { REACT_APP_JFS_PUBLIC_KEY } = process.env
  const PUBLIC_ENC_KEY: any = REACT_APP_JFS_PUBLIC_KEY

  let randomEncryptionKey = getRandomAlphaNumString(32)
  const encryptionKey = RSAEncryption(randomEncryptionKey, PUBLIC_ENC_KEY)
  const name = RootStore.agent.agentInfo.agentUserName
  const firstName = getFirstName(name)
  const lastName = getLastName(name)

  const aadharNum = !RootStore.agent.agentInfo.aadhaar.tokenPresent ? RootStore.agent.agentInfo.aadhaar.token : ''
  const aadhaarToken = RootStore.agent.agentInfo.aadhaar.tokenPresent ? RootStore.agent.agentInfo.aadhaar.token : ''

  return {
    // type: 'agentAuth',
    user: {
      userId: RootStore?.agent?.agentInfo?.agentUserLoginId,
      mobile: {
        mobileNumber: RootStore?.agent?.agentInfo?.agentMobileNumber,
        countryCode: '91',
      },
      entityType: 2,
      name: {
        firstName,
        lastName,
      },
    },
    scope: 'REQUEST',
    authenticateList: [
      {
        mode: fingerPrintDataAuthMode ?? 11,
        aadhaar: {
          ...(aadharNum && { number: aadharNum }),
          ...(aadhaarToken && { token: aadhaarToken }),
        },
        consent: btoa(consent),
        biometrics: fingerPrintData,
      },
    ],
    ...{
      secure: {
        encryptionKey: encryptionKey,
      },
    },
    purpose: 1,
  }
}

export const getFirstName = (name: string) => {
  name = name?.trim()
  let lastIndex = name.lastIndexOf(' ')
  if (lastIndex === -1) {
    lastIndex = name.length
  }
  return name.substr(0, lastIndex).trim()
}

export const getLastName = (name: string) => {
  name = name?.trim()
  return name.substr(name.lastIndexOf(' ')).trim()
}
